import React, { FC, useCallback, useEffect, useState } from "react";
import { Row, Col, Button, Dropdown } from "antd";
import { ReactSVG } from "react-svg";
import { PAGE_TYPES } from "utils/PageTypes";
import moment from "moment";
import { Link } from "react-router-dom";
import { popupCenter } from "utils/appUtil";
import { useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import { useDispatch } from "react-redux";
import { ENCRYPT_TOKEN } from "reducers/authReducer";

const pageTypeMap = {
  regular: "blue",
  event: "yellow",
  friend: "green",
};

const SearchCard: FC<{
  active?: boolean;
  onClick?: () => void;
  item?: SelectedSearchItem;
  calling?: boolean;
  onCopy?: any;
  onDelete?: any;
  onLeave?: any;
  screens?: any;
  setScreens?: any;
}> = ({
  active,
  onClick,
  item,
  calling,
  onCopy,
  onDelete,
  onLeave,
  screens,
  setScreens,
}) => {
  const [count, setCount] = useState<number>(0);
  // const type: string =
  //   item?.type && item.type === PAGE_TYPES.BROADCAST ? "orange" : "blue";
  const type: string =
    pageTypeMap[item?.persistent?.static?.metadata?.type] || "blue";
  const { allUsers } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();

  const handleVideoIconClick = () => {
    // popupCenter(
    //   window.location.origin + `/video/${item?.pageId}`,
    //   "beamLive Video Call",
    //   800,
    //   600
    // );

    const user = allUsers?.find(
      (obj) => obj.id === localStorage.getItem("RID")
    );
    dispatch(
      ENCRYPT_TOKEN({
        data: {
          payload: JSON.stringify({
            userId: localStorage.getItem("RID"),
            userBeamId: user?.beamId,
            connectionId: `${localStorage.getItem("CID")}`,
            pageId: item?.pageId,
            pageTitle:
              item?.persistent?.static?.metadata?.title ||
              (item?.persistent?.static?.metadata?.type === "friend" &&
              getFriendUser(item?.persistent?.static?.metadata?.members?.users)
                ?.beamId
                ? getFriendUser(
                    item?.persistent?.static?.metadata?.members?.users
                  )?.beamId
                : `Page ${item?.pageId}`),
          }),
        },
        callback: (token) => {
          // console.log("encrrypted token here", token);
          window.open(
            `${process.env.REACT_APP_VIDEO_URI}/room/${token.encryptedPayload}`,
            "_blank"
          );
          // console.log('url here', `${process.env.REACT_APP_ADMIN_API}?token=${token.encryptedPayload}`)
        },
      })
    );
  };

  let image: string = "";
  if (type === "yellow") {
    image = "/images/emergency-icon.svg";
    //   image = "/images/broadcast-icon.svg";
    // } else if (type === "green") {
    //   image = "/images/car-icon.svg";
  } else {
    image = "/images/community-blue-icon.svg";
  }

  // image = "/images/community-blue-icon.svg";

  let clsName = "search-card";
  if (active) {
    clsName += " active-card";
  }

  const stopPropagation = () => {
    // e.stopPropagation();
    console.log(item?.pageId);
  };

  const openInNewWindow = () => {
    // e.stopPropagation();
    window.open(window.location.origin + `/page/${item?.pageId}`, "_blank");
  };

  useEffect(() => {
    if (item) setCount(getCount(item));
  }, [item]);

  const getCount = (item: SelectedSearchItem) => {
    try {
      if (
        parseInt(item?.lastRead?.pageMessageId ?? -1) <
        parseInt(item?.lastSent?.pageMessageId ?? -1)
      ) {
        return 1;
      } else {
        return 0;
      }
    } catch (e) {
      return 0;
    }
  };

  const onDoubleClick = (page) => {
    console.log("on double click page", page);
    if (
      // page?.persistent?.static?.metadata?.type === "event" &&
      page?.persistent?.static?.profile?.subType
    ) {
      // popupCenter(
      //   `${process.env.REACT_APP_SHARED_URI}/${
      //     page?.persistent?.static?.profile?.subType
      //   }?userId=${localStorage.getItem(
      //     "RID"
      //   )}&connectionId=${localStorage.getItem("CID")}&pageId=${page.pageId}`,
      //   "CAD",
      //   window.innerWidth * 0.7,
      //   window.innerHeight * 0.9
      // );

      // dispatch({ type: "SET_SELECTED_ITEM", payload: {pageId: undefined} });
      setScreens({
        ...screens,
        iframe: true,
        iframeUrl: `${process.env.REACT_APP_SHARED_URI}/${
          page?.persistent?.static?.profile?.subType
        }?userId=${localStorage.getItem(
          "RID"
        )}&connectionId=${localStorage.getItem("CID")}&pageId=${page.pageId}`,
      });
    }
  };

  const getFriendUser = (members) => {
    const userIndex = Object.keys(members).find((x) => {
      return x !== localStorage.getItem("RID");
    });
    const user = allUsers?.find((obj) => obj.id === userIndex);
    return {
      profileImage: user?.profileImage?.urls?.original?.url,
      beamId: user?.beamId,
    };
    // return user?.beamId;
  };

  const menu = (
    <ul className="user-dropdown">
      <li
        onClick={() => {
          openInNewWindow();
        }}
      >
        <span className="ml-3">New window</span>
      </li>
      <li
        onClick={() => {
          onLeave(item?.pageId);
        }}
      >
        <span className="ml-3">Leave</span>
      </li>
      <li
        onClick={() => {
          onCopy("Copy", item?.pageId);
        }}
      >
        <span className="ml-3">Copy</span>
      </li>
      <li
        onClick={() => {
          onCopy("Merge", item?.pageId);
        }}
      >
        <span className="ml-3">Merge</span>
      </li>
      {/* <li onClick={stopPropagation}>
        <Link
          to={`/page/${item?.pageId}`}
          target="_blank"
          className="ml-3 text-white"
        >
          Open New Tab
        </Link>
      </li>
      <li onClick={openInNewWindow}>
        <span className="ml-3">Open New Window</span>
      </li> */}

      {item?.currentUserRole === "edit" && (
        <li
          onClick={() => {
            console.log("item here", item);
            onDelete(item?.pageId);
          }}
        >
          <span className="ml-3">Delete</span>
        </li>
      )}
    </ul>
  );
  return (
    <div
      className={`${clsName} ${
        item?.memberActive ? type : "white"
      }-card cursor-pointer`}
      onClick={onClick}
      onDoubleClick={() => {
        onDoubleClick(item);
      }}
    >
      {item?.nonpersistent?.static?.live?.status?.color && (
        <div
          className="spin-number"
          style={{
            background: item?.nonpersistent?.static?.live?.status?.color,
          }}
        >
          <span></span>
        </div>
      )}

      <Dropdown overlay={menu} placement="bottomRight" trigger={["click"]}>
        {item?.persistent?.static?.metadata?.type !== "friend" ? (
          <ReactSVG
            onClick={stopPropagation}
            src={image}
            className="colorable mark-icon"
          />
        ) : (
          <img
            src={
              getFriendUser(item?.persistent?.static?.metadata?.members?.users)
                ?.profileImage ?? "/images/users/user.png"
            }
            className="user-avatar"
            style={{ borderRadius: "50%" }}
            width={42}
            height={42}
            alt=""
          />
        )}
      </Dropdown>
      <div className="d-flex w-full">
        <div className="ml-2">
          <h3>
            {item?.persistent?.static?.metadata?.title ||
              (item?.persistent?.static?.metadata?.type === "friend" &&
              getFriendUser(item?.persistent?.static?.metadata?.members?.users)
                ?.beamId
                ? getFriendUser(
                    item?.persistent?.static?.metadata?.members?.users
                  )?.beamId
                : `Page ${item?.pageId}`)}
          </h3>
          <Row>
            <Col className="card-info date-info mr-2">
              <ReactSVG src="/images/refresh-icon.svg" className="svg-icon" />
              <p className="text-black">
                {moment(
                  item.lastSent?.updatedAt ??
                    item.persistent.static.metadata.createdAt
                ).format("MM/DD/YYYY hh:mm a")}
              </p>
            </Col>
            {item.memberActive ? (
              <Col
                className="card-info message-info mr-2"
                style={{
                  background: count !== 0 ? "rgb(80, 138, 250)" : undefined,
                }}
              >
                <p
                  className="text-black"
                  style={{ color: count !== 0 ? "#fff" : undefined }}
                >
                  {item.lastSent?.message ?? ""}
                </p>
              </Col>
            ) : (
              <Col
                className="card-info message-info mr-2"
                style={{
                  background: "rgb(80, 138, 250)",
                }}
              >
                <p className="text-black" style={{ color: "#fff" }}>
                  Pending Invitation
                </p>
              </Col>
            )}
          </Row>
        </div>

        {item?.activeIot && (
          <img
            className="ml-2 message-type cursor-pointer"
            src={
              item?.activeIot?.includes(localStorage.getItem("RID"))
                ? "/images/iot_blue.png"
                : "/images/IoT-icon.png"
            }
            alt=""
          />
        )}

        {calling && (
          <Button
            className="beam-btn ml-2"
            onClick={() => {
              handleVideoIconClick();
            }}
          >
            <ReactSVG src="/images/call-icon.svg" className="colorable" />
          </Button>
        )}
      </div>
    </div>
  );

  // switch (type) {
  //   case 'orange':
  //     return (
  //       <div className={`${clsName} ${type}-card cursor-pointer`} onClick={onClick}>
  //         <div className="spin-number"><span>15</span></div>
  //         <ReactSVG src={image} className="colorable mark-icon" />
  //         <div className="ml-2 w-full">
  //           <h3>Emergency page name</h3>
  //           <Row>
  //             <Col className="card-info date-info mr-2">
  //                 <ReactSVG src="/images/refresh-icon.svg" className="svg-icon" />
  //                 <p>{item.date}</p>
  //             </Col>
  //             <Col className="card-info message-info">
  //               <ReactSVG src="/images/message-black-icon.svg" className="colorable svg-icon" />
  //               <p>{item.title}</p>
  //             </Col>
  //           </Row>
  //         </div>
  //       </div>
  //     )
  //   case 'green':
  //     return (
  //       <div className={`${clsName} green-card cursor-pointer`} onClick={onClick}>
  //         <div className="spin-number"><span>15</span></div>
  //         <ReactSVG src={image} className="colorable mark-icon" />
  //         <div className="d-flex w-full">
  //           <div className="ml-2">
  //             <h3>03/02/21 - 11:33 AM</h3>
  //             <Row>
  //               <Col className="card-info date-info mr-2">
  //                   <ReactSVG src="/images/refresh-icon.svg" className="svg-icon" />
  //                   <p>03/02/21 - 12:36</p>
  //               </Col>
  //               <Col className="card-info message-info">
  //                 <ReactSVG src="/images/message-black-icon.svg" className="svg-icon"/>
  //                 <p>Last message long text</p>
  //               </Col>
  //             </Row>
  //           </div>
  //           <Button className="beam-btn ml-2">
  //             <ReactSVG src="/images/call-icon.svg" className="colorable" />
  //           </Button>
  //         </div>
  //       </div>
  //     )
  //   default:
  //     return (
  //       <div className={`${clsName} blue-card cursor-pointer`} onClick={onClick}>
  //         <div className="spin-number"><span>15</span></div>
  //         <ReactSVG src="/images/community-icon.svg" className="colorable mark-icon" />
  //         <div className="ml-2 w-full">
  //           <h3>Very Long Title Lorem ipsum</h3>
  //           <Row>
  //             <Col className="card-info date-info mr-2">
  //                 <ReactSVG src="/images/refresh-icon.svg" className="svg-icon" />
  //                 <p>03/02/21 - 12:36</p>
  //             </Col>
  //             <Col className="card-info message-info">
  //               <ReactSVG src="/images/message-black-icon.svg" className="svg-icon" />
  //               <p>Last message long text</p>
  //             </Col>
  //           </Row>
  //         </div>
  //       </div>
  //     )
  // }
};

export default SearchCard;
